import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { forward } from '../utills/Api';


function ConfirmationModal({setshowconfirm , showconfirm, setActiveTab, currentOrder, setIsLoading}) {
//   const [show, setShow] = useState(false);
  console.log("this i s showconfirm", showconfirm)
  const handleClose = () => setshowconfirm(false);

  const handleConfirm = () => {
    // Your confirmation logic here
    // For example, you can make an API call or perform some action
    // and then close the modal.
    const {id, status} = currentOrder;
    if(id && status)
    {
      forward({setIsLoading, setActiveTab, id, status});
      handleClose();
    }
  };

  return (
    <div>
      <Modal show={showconfirm} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Do you want to confirm?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ConfirmationModal;
